// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-modal-container .player-component {
  margin: 0 0 16px;
}

.video-modal-content .title-content,
.video-modal-content .title-actions-content {
  margin: 0 0 32px;
}
.video-modal-content .video-info,
.video-modal-content .topics-post-link-container,
.video-modal-content .title-content,
.video-modal-content .chart-card,
.video-modal-content .related-videos {
  padding: 0 16px;
}
.video-modal-content .video-info-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.video-modal-content .video-info-top .published-at {
  font-size: 14px;
}
.video-modal-content .content-ads-live-wrapper {
  margin-top: 20px;
  display: flex;
}
.video-modal-content .content-ads-live-wrapper .YellowBadge-customStyle {
  display: flex;
  align-items: center;
  justify-content: center;
}
.video-modal-content .content-ads-live-wrapper .YellowBadge-customStyle svg path {
  transform: translateX(20%);
}
.video-modal-content .video-modal-about {
  margin: 16px 0 32px;
}
.video-modal-content .info-content-grid {
  padding: 0 0 1px;
}
.video-modal-content .video-info {
  background: transparent;
}
.video-modal-content .video-info-addto-title .checkbox {
  margin-bottom: 16px;
  box-shadow: none;
}
.video-modal-content .video-info-addto-title {
  gap: 10px;
  display: flex;
}
.video-modal-content .video-info-addto-title button {
  margin-top: 3px;
}
.video-modal-content .video-info-addto-title .title {
  margin-bottom: 16px;
  word-break: break-word;
}
.video-modal-content .video-info-addto-title-with-checkbox {
  align-items: center;
}
.video-modal-content .video-info .video-creator {
  display: flex;
  align-items: center;
  font-size: 16px;
}
.video-modal-content .video-info .video-creator .video-creator-label {
  margin: 0 4px;
  color: var(--gray_dark1);
}
.video-modal-content .video-info .video-creator .video-creator-link .CreatorCardOnHover > h6 {
  position: relative;
  top: 4px;
}
.video-modal-content .video-info .video-creator .video-creator-link-public {
  align-self: baseline;
}
.video-modal-content .video-info .video-creator .video-creator-link-public-saved-search {
  align-self: auto;
}

.video-modal-content .content .mini-card-container {
  padding: 0;
}

@media only screen and (max-width: 600px) {
  .video-modal-about {
    display: none;
  }
  .related-videos {
    display: none;
  }
  .published-at {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/PublicVideoContent/index.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;AAAJ;;AAKE;;EAEE,gBAAA;AAFJ;AAKE;;;;;EAKE,eAAA;AAHJ;AAME;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAJJ;AAMI;EACE,eAAA;AAJN;AAQE;EACE,gBAAA;EACA,aAAA;AANJ;AAQI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AANN;AASQ;EACE,0BAAA;AAPV;AAaE;EACE,mBAAA;AAXJ;AAcE;EACE,gBAAA;AAZJ;AAeE;EACE,uBAAA;AAbJ;AAeM;EACE,mBAAA;EACA,gBAAA;AAbR;AAUI;EAME,SAAA;EACA,aAAA;AAbN;AAeM;EACE,eAAA;AAbR;AAgBM;EACE,mBAAA;EACA,sBAAA;AAdR;AAiBM;EACE,mBAAA;AAfR;AAmBI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAjBN;AAmBM;EACE,aAAA;EACA,wBAAA;AAjBR;AAsBU;EACE,kBAAA;EACA,QAAA;AApBZ;AAyBM;EACE,oBAAA;AAvBR;AAyBQ;EACE,gBAAA;AAvBV;;AA8BA;EACE,UAAA;AA3BF;;AA8BA;EACE;IACE,aAAA;EA3BF;EA8BA;IACE,aAAA;EA5BF;EA+BA;IACE,aAAA;EA7BF;AACF","sourcesContent":[".video-modal-container {\n  .player-component {\n    margin: 0 0 16px;\n  }\n}\n\n.video-modal-content {\n  .title-content,\n  .title-actions-content {\n    margin: 0 0 32px;\n  }\n\n  .video-info,\n  .topics-post-link-container,\n  .title-content,\n  .chart-card,\n  .related-videos {\n    padding: 0 16px;\n  }\n\n  .video-info-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .published-at {\n      font-size: 14px;\n    }\n  }\n\n  .content-ads-live-wrapper {\n    margin-top: 20px;\n    display: flex;\n\n    .YellowBadge-customStyle {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      svg {\n        path {\n          transform: translateX(20%);\n        }\n      }\n    }\n  }\n\n  .video-modal-about {\n    margin: 16px 0 32px;\n  }\n\n  .info-content-grid {\n    padding: 0 0 1px;\n  }\n\n  .video-info {\n    background: transparent;\n    &-addto-title {\n      .checkbox {\n        margin-bottom: 16px;\n        box-shadow: none;\n      }\n\n      gap: 10px;\n      display: flex;\n\n      button {\n        margin-top: 3px;\n      }\n\n      .title {\n        margin-bottom: 16px;\n        word-break: break-word;\n      }\n\n      &-with-checkbox {\n        align-items: center;\n      }\n    }\n\n    .video-creator {\n      display: flex;\n      align-items: center;\n      font-size: 16px;\n\n      .video-creator-label {\n        margin: 0 4px;\n        color: var(--gray_dark1);\n      }\n\n      .video-creator-link {\n        .CreatorCardOnHover {\n          > h6 {\n            position: relative;\n            top: 4px;\n          }\n        }\n      }\n\n      .video-creator-link-public {\n        align-self: baseline;\n\n        &-saved-search {\n          align-self: auto;\n        }\n      }\n    }\n  }\n}\n\n.video-modal-content .content .mini-card-container {\n  padding: 0;\n}\n\n@media only screen and (max-width: 600px) {\n  .video-modal-about {\n    display: none;\n  }\n\n  .related-videos {\n    display: none;\n  }\n\n  .published-at {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
